import React from "react";
import MainPage from "../Components/Shared/MainPage";
import { Card, CardBody, Row, Col } from "reactstrap";

export default function CorporateSolutions(props) {
  return (
    <MainPage title="Corporate Solutions">
      <div className="px-1 mb-5 px-sm-5 container-fluid">
        <div className="text-center">
          <h5>Business Gifts, Events, Promotions, Employee Recognition</h5>
        </div>
        <div className="jumbotron text-center">
          <h3>
            'Giving Back' with charitable gifting for clients and employees.
          </h3>
          <h5>
            <em>Coping with challenging times...</em>
            <br />
            <br />
            Enhance Virtual Events
            <br />
            Keep in touch with your clients.
            <br />
            <em>Help charities when they need it the most.</em>
          </h5>
          <br />
          <em>
            Special bulk purchase offer.{" "}
            <a href="/Purchase/BulkDiscount/">Learn more</a>...
          </em>
          <br />
          <h5>Speaks volumes about the company's values.</h5>
        </div>
        <Row>
          <Col lg={8} md={12}>
            <p>
              <strong>Corporate Customization Suite:</strong>
              <br />
              Our robust, online package provides outstanding branding, for
              large corporations and small businesses alike. We offer your
              business the best program for cause-affinity, proven to be
              effective in enhancing customer loyalty.
            </p>
            <p>
              <strong>
                All corporate and business accounts receive these options:
              </strong>
            </p>
            <ul>
              <li>
                <a href="/Purchase/eCards">Custom Digital eGifts</a>
              </li>
              <li>
                <a href="/Purchase/BulkDiscount/">
                  Bulk eGift Pricing
                </a>
              </li>
              <li>
                <a href="/Purchase/CustomPhysicalCards/">Custom Gift Cards</a>
              </li>
              <li>
                <a href="/Purchase/PhysicalCards">Stock Physical Cards</a>
              </li>
              <li>
                <a href="/Purchase/RedemptionCodes">
                  Unique Codes to Mail-merge
                </a>
              </li>
              <li>
                <a href="/custompageadmin/CreateCustomRedemptionPage/">
                  Custom Redemption Page - Logo and Caption
                </a>
              </li>
              <li>
                <a href="/Login.aspx?CA=1&ReturnPage=^Corporate^MyCharities.aspx&ReturnResponse=CRP_NC">
                  Custom Charity List
                </a>
              </li>
              <li className="link">Pay-By-Check</li>
            </ul>
          </Col>
          <Col lg={4} md={6} sm={10} xs={12}>
            <Card>
              <CardBody style={{ backgroundColor: "#e9ecef" }}>
                <img src="/Images/Quotes.gif" alt="Swag bag-goodie bag-giveaway-virtual event-attendees." />
                <br />
                <br />
                We used this as a customer gift, and it was extremely well
                received!
                <br />
                I love this website, we will definitely be using again!
                <br />
                <br />
                <img src="/Images/BrookeRodruigez.png" alt="Brooke Rodruigez" />
              </CardBody>
            </Card>
          </Col>
        </Row>
        <h3>Create your corporate account</h3>
        <p>
          <em>
            The corporate customization suite offers a dramatic, engaging method
            of delivering a meaningful message to clients about your commitment
            to charitable giving.
          </em>
        </p>
        <p>
          Create eGifts with your unique graphic design or order bulk, custom
          gift cards.
          <br />
          You can even have affinity with specific charitable causes. Pre-select
          a group of charities to highlight on your branded, customized
          redemption page. FREE when using our online wizard.
        </p>
        <p>
          <a href="/Login.aspx?CA=1&ReturnPage=^Purchase">
            <em>Create your account now...</em>
          </a>
        </p>
        <p className="very-small">
          <em>
            CharityChoice gifts are 100% Tax Deductible!
            <br />
            Over 1000, including 250 charities for gift recipients to choose
            from.
          </em>
        </p>
      </div>
    </MainPage>
  );
}
